import React from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

/**
 * Generic 404 catch-all — matched by <Route path="*" />. Rendered whenever a
 * user hits a typo or dead link. Gives them the current URL for context, a
 * clear message, and two sensible next actions (Browse services / Home).
 */
export default function NotFound() {
  const loc = useLocation();
  return (
    <div className="App" data-testid="not-found-page">
      <Header hideSearch />
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        <div
          className="mx-auto flex items-center justify-center w-20 h-20 rounded-full border"
          style={{ borderColor: "var(--gf-border-strong)", color: "var(--gf-text-muted)" }}
          aria-hidden="true"
        >
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="7" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
            <line x1="8" y1="11" x2="14" y2="11" />
          </svg>
        </div>
        <div className="uppercase text-xs tracking-[0.25em] mt-6" style={{ color: "var(--gf-text-muted)" }}>
          404 · Page not found
        </div>
        <h1 className="font-display text-4xl sm:text-5xl mt-3" style={{ color: "var(--gf-text)" }}>
          We couldn&rsquo;t find that page
        </h1>
        <p className="mt-3 text-sm max-w-md mx-auto" style={{ color: "var(--gf-text-muted)" }}>
          The link you followed may be broken, or the page may have moved. Let&rsquo;s
          get you back on track.
        </p>
        <div className="mt-2 text-[11px] break-all" style={{ color: "var(--gf-text-muted)" }}>
          Requested: <span style={{ color: "var(--gf-text-soft)" }}>{loc.pathname}</span>
        </div>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/services"
            data-testid="not-found-browse-btn"
            className="px-5 py-2 rounded-full font-medium"
            style={{ background: "var(--gf-accent)", color: "var(--gf-on-accent)" }}
          >
            Browse services
          </Link>
          <Link
            to="/"
            data-testid="not-found-home-btn"
            className="px-5 py-2 rounded-full font-medium border"
            style={{ borderColor: "var(--gf-border-strong)", color: "var(--gf-text)" }}
          >
            Back to home
          </Link>
        </div>
        <div className="mt-6 text-xs" style={{ color: "var(--gf-text-muted)" }}>
          Still stuck? <Link to="/help" className="underline" style={{ color: "var(--gf-accent)" }}>Visit our help centre</Link>.
        </div>
      </div>
      <Footer />
    </div>
  );
}
